__turbopack_context__.v({
  "b2ilogo": "MbaLandingHeader-module-scss-module__u36Zoq__b2ilogo",
  "b2isection": "MbaLandingHeader-module-scss-module__u36Zoq__b2isection",
  "divider": "MbaLandingHeader-module-scss-module__u36Zoq__divider",
  "enrollNowCROPage": "MbaLandingHeader-module-scss-module__u36Zoq__enrollNowCROPage",
  "regionDivider": "MbaLandingHeader-module-scss-module__u36Zoq__regionDivider",
  "regionLabel": "MbaLandingHeader-module-scss-module__u36Zoq__regionLabel",
  "regionSection": "MbaLandingHeader-module-scss-module__u36Zoq__regionSection",
  "schoolname": "MbaLandingHeader-module-scss-module__u36Zoq__schoolname",
});
